/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectItemSampleCommandResult } from '../../models/create-project-item-sample-command-result';

export interface ApiProjectItemSamplesCreateProjectItemSamplePost$Params {
      body?: {
'Description'?: string;
'Notes'?: string;
'ProjectItemId'?: string;
'ProjectItemSubmittalId'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectItemSamplesCreateProjectItemSamplePost(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesCreateProjectItemSamplePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemSampleCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesCreateProjectItemSamplePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectItemSampleCommandResult>;
    })
  );
}

apiProjectItemSamplesCreateProjectItemSamplePost.PATH = '/api/ProjectItemSamples/CreateProjectItemSample';
